import { capitalize } from './string_util'

export const shortDate = (longDate: string): string => (longDate ? longDate.slice(0, 10) : '-')

export const getTimeFromDate = (date: string) => (date ? date.slice(12, 20) : '-')

export const getHour = (date: Date) =>
  `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`

export const formatDate = (date: Date) => {
  const formattedDate = new Intl.DateTimeFormat('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  }).format(date)

  const day = formattedDate.split(' ')[0].charAt(0).toUpperCase() + formattedDate.split(' ')[0].slice(1).replace(',', '')
  const number = formattedDate.split(' ')[1]
  const month = formattedDate.split(' ')[3].charAt(0).toUpperCase() + formattedDate.split(' ')[3].slice(1)

  return `${day} ${number} de ${month}`
}

export const formatHoverDate = (date: Date) => {
  const weekday = new Intl.DateTimeFormat('es-ES', {
    weekday: 'long'
  }).format(date)

  const day = date.getDate()
  const month = date.getMonth() + 1

  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  return `${capitalize(weekday)} ${day}/${month} - ${hours}:${minutes}`
}

export const formatDateShort = (date: string) => {
  const [day, month, year] = date.split('-').map(Number)

  const parsedDate = new Date(year, month - 1, day)

  const formattedDate = new Intl.DateTimeFormat('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  }).format(parsedDate)

  const parts = formattedDate.split(' ')

  const weekday =
    parts[0].charAt(0).toUpperCase() +
    parts[0].slice(1).replace(',', '')

  const dayNumber = parts[1]

  const monthName = parts[3]

  return `${weekday} ${dayNumber} de ${monthName} ${year}`
}

export const parseDate = (date: string, dateType: number) => {
  if (dateType === 1) {
    const [datePart, timePart] = date.split(', ')

    const [day, month, year] = datePart.split('-').map(Number)

    const [time, meridian] = timePart.split(' ')
    const [_hours, minutes, seconds] = time.split(':').map(Number)

    let hours = _hours

    if (meridian && meridian.toLowerCase().includes('p') && hours !== 12) {
      hours += 12
    }
    if (meridian && meridian.toLowerCase().includes('a') && hours === 12) {
      hours = 0
    }
    const parsedDate = new Date(year, month - 1, day, hours, minutes, seconds)

    return parsedDate
  }
  return new Date(date)
}

export const getDifferenceInDays = (date1: Date, date2: Date) => {
  const differenceInTime = date2.getTime() - date1.getTime()
  return Math.ceil(differenceInTime / (1000 * 60 * 60 * 24))
}
